import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'

const Tab = ({ isActive, children, ...tabProps }) => (
  <div
    className={classNames(style.Tab, { [style.activeTab]: isActive })}
    {...tabProps}
  >
    {children}
  </div>
)

Tab.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node,
}

Tab.defaultProps = {
  isActive: false,
}

export default Tab
